export default __webpack_public_path__ + "static/media/logo-mobile.fc1f1625.svg";